if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.formWrapper = document.getElementById("product-form-wrapper");
        this.header = document.getElementById("Header");
        this.stickyAtc = this.firstElementChild;
        this.stickyAtc.id = "sticky-atc";
        this.isVisible = false;
        this.animation = null;
      }

      connectedCallback() {
        this.setupObserver();
        this.clean(); // Clean up any existing sticky elements
      }

      setupObserver() {
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this));
        this.observer.observe(this.formWrapper);
      }

      clean() {
        const oldSticky = this.header.querySelectorAll("#sticky-atc");
        oldSticky.forEach(sticky => sticky.remove());
      }

      handleIntersect(entries) {
        const [entry] = entries;
        const formRect = this.formWrapper.getBoundingClientRect();
        const isFormAboveFold = formRect.bottom < 100;

        if (!entry.isIntersecting && isFormAboveFold) {
          this.show();
        } else {
          this.hide();
        }
      }

      show() {
        if (!this.isVisible) {
          if (window.innerWidth < 1024) {
            document.body.appendChild(this.stickyAtc);
          } else {
            this.header.appendChild(this.stickyAtc);
          }

          this.animation = this.stickyAtc.animate(
            [
              { transform: 'translateY(-100%)', opacity: 0 },
              { transform: 'translateY(0)', opacity: 1 }
            ],
            {
              duration: 300,
              easing: 'ease-out',
              fill: 'forwards'
            }
          );
          document.body.classList.add("sticky-atc-is-active");
          this.isVisible = true;
        }
      }

      hide() {
        if (this.isVisible) {
          if (this.animation) {
            this.animation.cancel();
          }
          this.animation = this.stickyAtc.animate(
            [
              { transform: 'translateY(0)', opacity: 1 },
              { transform: 'translateY(-100%)', opacity: 0 }
            ],
            {
              duration: 300,
              easing: 'ease-in',
              fill: 'forwards'
            }
          );
          this.animation.onfinish = () => {
            if (this.stickyAtc.parentElement === document.body ||
                this.stickyAtc.parentElement === this.header) {
              this.stickyAtc.remove();
            }
            document.body.classList.remove("sticky-atc-is-active");
            this.isVisible = false;
          };
        }
      }

      disconnectedCallback() {
        this.observer.disconnect();
        if (this.animation) {
          this.animation.cancel();
        }
      }
    }
  );
}
